<template>
  <div :class="billItemClasses">
    <div class="bill-item__header flex flex--align-center flex--justify-between">
      <div>
        <p class="label">{{item.app_name}}</p>
        <p class="value">{{item.bill_date.substring(0, 4)}}年{{item.bill_date.substring(5)}}月账单</p>
      </div>
      <div class="bill-item__right">
        <p class="label">账单时间：{{item.create_time | formatDate('YYYY-MM-DD')}}</p>
        <p class="value">¥{{item.amount}}｜{{billStatusMap[item.billing_status]}}</p>
      </div>
    </div>
    <div class="bill-item__body">
      <div class="flex flex--justify-between flex--align-center"
           :key="index"
           v-for="(detail, index) in item.billing_detail">
        <div>
          <p class="label">账单明细</p>
          <p class="value">{{detail.order_content}}</p>
        </div>
        <div class="bill-item__right">
          <p class="label">费用</p>
          <p class="value">¥{{detail.amount}}</p>
        </div>
      </div>
    </div>
    <div class="bill-item__footer" v-if="item.billing_status !== 'PAID'">
      <Button type="text"
              @click="handleNoticeRecharge"
              :disabled="item.pay_flag === 'Y'">我已转账</Button>
      <Button type="primary"
              @click="handleToPay"
              shape="circle">去付款</Button>
    </div>
  </div>
</template>

<script>
import { billStatusMap } from '@/config/enum.config';
import { confirmBillPay } from '@/api/settlement/bill';
import { mapMutations } from 'vuex';

export default {
  name: 'billItem',
  props: {
    item: Object,
  },
  data() {
    return {
      billStatusMap,
      loading: false,
    };
  },
  computed: {
    billItemClasses() {
      const classes = ['bill-item'];
      classes.push(this.item.billing_status.toLowerCase());
      return classes;
    },
  },
  methods: {
    ...mapMutations(['updateState']),
    async handleNoticeRecharge() {
      this.$emit('on-loading', true);
      const res = await confirmBillPay({
        id: this.item.id,
      });
      if (res) {
        this.$emit('on-pay-success', {
          ...this.item,
          pay_flag: res.pay_flag,
          billing_status: res.billing_status,
        });
        this.$Message.success('操作成功');
      }
      this.$emit('on-loading', false);
    },
    handleToPay() {
      const {
        amount, contract_number, id, billing_detail,
        pay_flag,
      } = this.item;
      const lineList = [];
      billing_detail.forEach((item) => {
        lineList.push({
          name: item.order_content,
          value: item.amount,
          type: ' ',
        });
      });

      const rechargeDetail = {
        lineList,
        line4: {
          name: '待支付金额',
          value: amount,
        },
        num: contract_number,
        id,
        pay_flag,
      };
      this.updateState({
        rechargeType: '2',
        rechargeVisible: true,
        rechargeDetail,
      });
    },
  },
};
</script>

<style lang="less">
  @prefix: ~'bill-item';
  .@{prefix}{
    margin-bottom: 8px;
    .box-shadow;
    border-radius: 8px;
    background-color: #fff;
    position: relative;
    &.topaid{
      .@{prefix}{
        &__header{
          .value{
            color: rgb(81, 69, 139);
          }
        }
      }
    }
    &.overdue{
      .@{prefix}{
        &__header{
          .value{
            color: rgb(239, 108, 0);
          }
        }
        &__footer {
          .ivu-btn {
            &.ivu-btn-text {
              color: rgb(239, 108, 0);
            }
            &.ivu-btn-primary {
              background-color: rgb(239, 108, 0);
            }
          }
        }
      }
    }
    &__right{
      width: 180px;
    }
    .label{
      color: rgba(0, 0, 0, 0.54);
      font-size: 12px;
      line-height: 16px;
    }
    .value{
      color: rgba(0, 0, 0, 0.87);
    }
    &__header{
      padding: 8px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      .value{
        font-size: 18px;
        line-height: 24px;
      }
    }
    &__body{
      padding: 8px 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      .flex{
        margin-bottom: 16px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .value{
        font-size: 14px;
        line-height: 16px;
        margin-top: 8px;
      }
    }
    &__footer{
      text-align: right;
      padding: 8px 16px;
      .ivu-btn{
        margin-left: 16px;
        padding: 0;
        width: 90px;
        height: 36px;
        font-weight: bold;
        border: none;
        box-shadow: none;
        &.ivu-btn-text{
          color: @primary-color;
          &:hover{
            color: @link-hover-color;
          }
          &[disabled] {
            color: rgba(0, 0, 0, .56);
            &:hover{
              color: rgba(0, 0, 0, .56);
            }
          }
        }
      }
    }
  }
</style>
